import { useState, useCallback } from 'react';

/**
 * Forces a re-render.
 * @see https://github.com/reach/reach-ui/blob/85e6e764c7acc336fd3f99eca80c3fa180882260/packages/utils/src/use-force-update.ts
 */
function useForceUpdate() {
  const [, dispatch] = useState(Object.create(null));
  return useCallback(() => {
    dispatch(Object.create(null));
  }, []);
}

export { useForceUpdate };
